export const ENEMY_COLORS = [
    '#ff0066', '#00ff88', '#ffaa00',
    '#00aaff', '#ff00ff', '#88ff00'
];

// Geometry Wars–style deep black voids with tinted grid accents
export const BACKGROUNDS = [
    { id: 'default', name: 'Deep Space', color: '#03040a', accent: '#0a2848' },
    { id: 'purple', name: 'Purple Nebula', color: '#08040f', accent: '#2a1050' },
    { id: 'green', name: 'Toxic Wasteland', color: '#030a06', accent: '#0a3020' },
    { id: 'red', name: 'Mars Desert', color: '#0a0306', accent: '#3a1020' },
    { id: 'blue', name: 'Ocean Depths', color: '#02060c', accent: '#0a2040' }
];

// Visual / juice tuning
export const VFX = {
    SHAKE_DECAY: 0.86,
    HIT_SHAKE: 4,
    DEATH_SHAKE: 7,
    BOSS_DEATH_SHAKE: 14,
    MAX_PARTICLES: 280,
    // Soft caps used when quality is high (PerfStats may lower these)
    MAX_PARTICLES_MED: 180,
    MAX_PARTICLES_LOW: 100,
};

export const BOSS_SPAWN_INTERVAL = 30000; // Every 30 seconds
export const BOSS_HP_MULTIPLIER = 10;
export const BOSS_SIZE_MULTIPLIER = 2;

// Wave spawn batching — every WAVE_BATCH_GROWTH_INTERVAL waves, one more enemy
// spawns per tick (capped at WAVE_SPAWN_BATCH_MAX)
export const WAVE_BATCH_GROWTH_INTERVAL = 4; // waves between each +1
export const WAVE_SPAWN_BATCH_MAX = 5;       // never spawn more than this per tick

// World dimensions — larger than any single viewport
export const WORLD_WIDTH  = 4000;
export const WORLD_HEIGHT = 4000;

// Combat — only engage targets you can actually see
export const SHOOT_RANGE = 420;          // auto-aim max distance (world units)
export const SHOOT_RANGE_AIMED = 520;    // twin-stick free-aim still limited by projectile lifetime
export const PROJECTILE_MAX_DIST = 480;  // hard travel distance for bullets

// Inventory / ship
export const INVENTORY_SLOTS = 24;
export const SHIP_SLOTS = [
    'weapon', 'weapon2', 'shield', 'engine', 'reactor',
    'hull', 'sensor', 'cargo', 'special', 'wing'
];
